import {useQuery} from 'react-query';
import { getSaleChart } from 'services/myAd/chart/salechart';

const useGetSaleChart = (guid: string) => {
  const {data: postChartData, isLoading} = useQuery(
    ['post-chart-sale', guid],
    getSaleChart,
  );
  return {postChartData, isLoading};
};

export default useGetSaleChart;
